// src/components/alerts/AlertToastItem.jsx
import React from "react";
import { AlertTriangle, Bell } from "lucide-react";

const AlertToastItem = ({ alert }) => {
  const doc = alert.document;
  const isRead = alert.is_read;
  const hasDoc = !!doc;

  // ✅ created_at 안전 처리
  let date = "";
  let time = "";

  if (alert.created_at) {
    // ISO / 공백 포맷 모두 대응
    const normalized = alert.created_at.replace("T", " ");
    const parts = normalized.split(" ");
    date = parts[0] || "";
    time = parts[1]?.slice(0, 5) || "";
  }

  const statusIcon = alert.is_urgent ? (
    <div className="p-2 rounded-full bg-red-100">
      <AlertTriangle size={20} className="text-red-600" />
    </div>
  ) : (
    <div className="p-2 rounded-full bg-blue-100">
      <Bell size={20} className="text-blue-600" />
    </div>
  );

  return (
    <div className="w-full">
      <div className="p-4 flex gap-3 items-start">
        {/* 상태 아이콘 */}
        <div className="shrink-0">
          {statusIcon}
        </div>

        {/* 본문 */}
        <div className="flex-1 min-w-0 space-y-2">
          <div className="text-sm font-bold leading-snug text-gray-900">
            {alert.message}
          </div>

          <div className="flex items-center gap-2 text-xs text-gray-600 min-w-0">
            {hasDoc ? (
              <>
                <span className="inline-flex items-center px-2 py-1 rounded-md bg-white/80 text-[11px] font-semibold whitespace-nowrap shadow-sm">
                  {(doc.doc_type || "").toUpperCase()}
                </span>
                <span className="truncate flex-1 font-medium">
                  {doc.title}
                </span>
              </>
            ) : (
              <span className="truncate flex-1 font-medium">
                프로젝트 공유 자료실
              </span>
            )}
          </div>

          {/* 시간 */}
          {(date || time) && (
            <div className="text-[11px] text-gray-500 font-medium">
              {date && <span>{date}</span>}
              {date && time && <span className="mx-1">•</span>}
              {time && <span>{time}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertToastItem;
